module.exports = __webpack_public_path__ + "media/A30.5577ac0c.mp3";